"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _isLoggedOut["default"];
  }
});
var _isLoggedOut = _interopRequireDefault(require("./isLoggedOut"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }